export default "__VITE_ASSET__DF3$iyU0__"